import React, { FunctionComponent } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ButtonProps, EditButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { getBulkEditCloudAssetContentPageHref } from "../../../../../../../AssetsRoutes";

export type BulkEditCloudAssetContentButtonProps = ButtonProps;

export const BulkEditCloudAssetContentButton: FunctionComponent<BulkEditCloudAssetContentButtonProps> = ({
    disabled
}) => {
    const { assetId } = useParams<{ assetId: string }>();
    const history = useHistory();

    const moveToBulkEditContentPage = () => {
        const href = getBulkEditCloudAssetContentPageHref(assetId);
        history.push(href);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={moveToBulkEditContentPage}
                disabled={disabled}
                label="Bulk edit content"
                isLabeled
                testId="bulk-edit-content"
            />
        </AuthorizationWrapper>
    );
};
